import script from "./ProfileCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileCard.vue?vue&type=script&setup=true&lang=js"

import "./ProfileCard.vue?vue&type=style&index=0&id=535c9934&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-535c9934"]])

export default __exports__